import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material';



const BusyIndicatorWrapper = styled("div")({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 100,
});

const Label = styled("div")({ marginTop: 5 });

export default function BusyIndicator({ label }) {
  return (
    <BusyIndicatorWrapper>
      <CircularProgress />
      {label && <Label>{label}</Label>}
    </BusyIndicatorWrapper>
  );
}

BusyIndicator.propTypes = {
  label: PropTypes.string,
};

BusyIndicator.defaultProps = {
  label: '',
};
